// Bloco "COMO REPRESENTAR A OMNICORE" (frame 585:8619): eyebrow + lead + linhas
// com o hábito a evitar riscado à esquerda e a atitude certa em destaque à
// direita, separadas por divisores.
// rows: array de { dont, do: string }
export default function DoDontRows({ heading = '', lead = '', rows = [] }) {
  return (
    <div className="w-full px-20">
      {heading && (
        <h2 className="pt-10 font-inter-extrabold text-2xl tracking-[-0.02em] text-[#454545]">
          {heading}
        </h2>
      )}
      {lead && (
        <p className="pt-2 pb-6 font-inter-regular text-base leading-[1.08] text-[#707070]">
          {lead}
        </p>
      )}

      <ul className="flex flex-col pb-12">
        {rows.map((row, index) => (
          <li
            key={index}
            className="flex flex-col gap-1 border-[#D9D9D9] border-t py-5 last:border-b md:flex-row md:items-center md:justify-between md:gap-6"
          >
            <span className="font-inter-regular text-base leading-[1.08] text-[#AEAEAE] line-through">
              {row.dont}
            </span>
            <span className="font-inter-semibold text-base leading-[1.08] text-[#454545] md:w-1/2">
              {row.do}
            </span>
          </li>
        ))}
      </ul>
    </div>
  )
}
